
export default {
    components: {
        Breadcrumbs: () => import("~/components/global/Breadcrumbs"),
        PageContent: () => import("~/components/search/GlobalResults"),
    },
    data: () => ({
        items: [],
        loading: false,
        searchError: "",
        requestId: 0,
    }),
    computed: {
        keyword() {
            const value = this.$route.query.keyword || this.$route.query.a;
            return typeof value === "string" ? value.trim() : "";
        },
        sortBy() {
            return (this.$route.query.sort_by || this.$route.query.sort) === "date_asc" ? "date_asc" : "date_desc";
        },
    },
    watch: {
        "$route.query": "loadResults",
    },
    mounted() {
        this.loadResults();
    },
    beforeDestroy() {
        this.requestId += 1;
    },
    methods: {
        async submitSearch({ keyword, sort_by }) {
            if (keyword === this.keyword && sort_by === this.sortBy) {
                return this.loadResults();
            }
            await this.$router.push({ path: "/search", query: { keyword, sort_by } });
        },
        async loadResults() {
            const requestId = ++this.requestId;
            this.items = [];
            this.searchError = "";
            this.loading = Boolean(this.keyword || this.$route.query.sort_by || this.$route.query.sort);
            if (!this.loading) return;
            try {
                const response = await this.$axios.$post("web/global/deep-search", { keyword: this.keyword, sort_by: this.sortBy }, { timeout: 60000 });
                if (requestId !== this.requestId) return;
                const dataset = this.decryptionData(response?.data?.attributes?.encrypted);
                if (!dataset) throw new Error("Invalid search response");
                const groups = [
                    ["pages", "PAGE"],
                    ["product_categories", "CATEGORY"],
                    ["products", "PRODUCT"],
                    ["news", "NEWS"],
                ];
                this.items = groups.flatMap(([key, type]) =>
                    (dataset[key] || []).map((item) => ({
                        id: `${key}-${item.id}`,
                        type,
                        title: item.name || item.title || "",
                        description: item.description || item.meta_description || "",
                        path: item.path,
                    })),
                );
            } catch (error) {
                if (requestId === this.requestId) this.searchError = "Search is unavailable right now. Please try again.";
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        },
    },
    head() {
        return {
            title: "Search | Malayan Insurance (Philippines)",
            link: [{ hid: "canonical", rel: "canonical", href: "https://malayan.com/search" }],
            meta: [
                { hid: "robots", name: "robots", content: "noindex, follow" },
                { hid: "description", name: "description", content: "Search Malayan Insurance pages, products and news." },
            ],
        };
    },
};
